import { type FieldValues, useController } from 'react-hook-form';

import { Input, type InputProps } from '~/components/Input';

import { FormField, type FormFieldProps } from '../../FormField';

export type FormFieldInputProps<TFormFields extends FieldValues> = Omit<
  FormFieldProps<TFormFields>,
  'children'
> &
  Omit<InputProps, 'name' | 'className'>;

export function FormFieldInput<TFormFields extends FieldValues>({
  name,
  label,
  className,
  disabled = false,
  readOnly = false,
  ...inputProps
}: FormFieldInputProps<TFormFields>) {
  const {
    field,
    fieldState: { invalid },
  } = useController({ name, disabled });

  return (
    <FormField
      name={name}
      label={label}
      className={className}
      disabled={disabled}
      readOnly={readOnly}
    >
      <Input
        {...field}
        state={invalid ? 'error' : undefined}
        aria-labelledby={name}
        {...inputProps}
        disabled={disabled}
        readOnly={readOnly}
      />
    </FormField>
  );
}

FormFieldInput.displayName = 'FormFieldInput';
